// extracted by mini-css-extract-plugin
module.exports = {"buttons_wrapper":"styles_buttons_wrapper__1NClj","btn":"styles_btn__3o0_G","price_wrapper":"styles_price_wrapper__XqW-z"};